var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEssentialChemicals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    rx: 40,
    fill: "#69348e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286,112.36a13.57,13.57,0,0,0-13.56,13.56V249.15a14.49,14.49,0,1,1-29,0V125.92a13.58,13.58,0,0,0-13.56-13.56,4,4,0,0,0,0,8,5.56,5.56,0,0,1,5.55,5.56V249.15a22.49,22.49,0,1,0,45,0V125.92a5.56,5.56,0,0,1,5.56-5.56,4,4,0,0,0,0-8ZM184.43,192.08a24,24,0,0,1-5-14.59V125.92a5.56,5.56,0,0,1,5.55-5.56,4,4,0,1,0,0-8,13.57,13.57,0,0,0-13.55,13.56v51.57A32.11,32.11,0,0,0,178.09,197l30.28,39.38a17,17,0,0,1-13.45,27.3H119a17,17,0,0,1-13.44-27.3L135.87,197a32.12,32.12,0,0,0,6.63-19.47V125.92a13.58,13.58,0,0,0-13.56-13.56,4,4,0,0,0,0,8,5.57,5.57,0,0,1,5.56,5.56v51.57a24.06,24.06,0,0,1-5,14.59L99.25,231.47A25,25,0,0,0,119,271.64h75.88a25,25,0,0,0,19.79-40.17Zm-36.58,23.24h18.27a4,4,0,0,0,0-8H147.85a4,4,0,1,0,0,8Zm0,18.3h18.27a4,4,0,0,0,0-8H147.85a4,4,0,0,0,0,8Zm0,18.3h18.27a4,4,0,0,0,0-8H147.85a4,4,0,0,0,0,8Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M265.58,210.74H250.22a4,4,0,0,1,0-8h15.36a4,4,0,0,1,0,8Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssentialChemicals);
export default __webpack_public_path__ + "static/media/essential-chemicals.15b210dd10d21e4b3f7d6a906657990d.svg";
export { ForwardRef as ReactComponent };